import Footer from "../footer/Footer";
import HeaderTwo from "../header/HeaderTwo";


export default function TermsAndCondition() {
    return (
        <>
        <HeaderTwo/>
        <div className="term-condition">
           <p> Terms and Conditions
            Effective Date: 06 Aug 2025
            Last Updated: 06 Aug 2025

            Welcome to Obigin Games, developed and maintained by Obigin Media Labs LLP, based in Hyderabad, India. By downloading, accessing, or using any of our games or services, you agree to the following terms:

            1. Acceptance of Terms
            These Terms govern your use of our websites, mobile applications, and all related features. If you do not agree, do not use our services.

            2. Age Restrictions
            You must be 13 years or older to use our games. If under 18, you must have parental consent.

            3. Account and Registration
            Some features may require you to register for an account. You are responsible for safeguarding your credentials and for any activity under your account.

            4. In-App Purchases
            Our games may offer optional in-app purchases. All purchases are non-refundable unless required by local law. Prices are subject to change without notice.

            5. User Conduct
            You agree not to:

            Use cheats, exploits, or unauthorized third-party tools.

            Upload harmful, defamatory, or unlawful content.

            Harass or impersonate other players.

            We reserve the right to suspend or ban accounts that violate these rules.

            6. Intellectual Property
            All content, trademarks, and code are the property of Obigin Media Labs LLP. You may not copy, modify, or distribute our assets without prior written permission.

            7. Game Updates and Changes
            We may modify or discontinue game features at any time. We are not liable for any data loss or disruption.

            8. Limitation of Liability
            We provide our games “as is,” without warranties of any kind. We are not liable for any damages resulting from gameplay, technical issues, or third-party interactions.

            9. Governing Law
            These Terms are governed by the laws of India. Disputes will be subject to the jurisdiction of courts in Hyderabad, Telangana.

            10. Contact
            For any questions, contact us at:
            [support@obigin.com]
            Obigin Media Labs LLP, Hyderabad, India</p>
        </div>
        <Footer/>
        </>
    );
}